module.exports = __webpack_public_path__ + "static/img/img18.d88678e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img18.png
// module id = dziR
// module chunks = 1